export default "__VITE_ASSET__BBfzrVNH__"